// import external dependencies
import 'jquery';
import AOS from 'aos';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleBarriques from './routes/single-barriques';
import singleProduits from './routes/single-produits';
//import singleAnalyses from './routes/single-analyses';
import templateContact from './routes/template-contact';
import templateBibliotheque from './routes/template-bibliotheque';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  singleBarriques,
  singleProduits,
  //singleAnalyses,
  // Template
  templateBibliotheque,
  templateContact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
jQuery(window).on('load', () => AOS.init({
  offset: 0,
  duration: 600,
  easing: 'ease-in-sine',
  delay: 100,
  placement: 'top-bottom',
}));



// WEBPACK FOOTER //
// ./scripts/main.js